<template>
  <div class="date_619">
    <img class="pc_619_bg" src="https://summit-img.geekpark.net/r2020/pc_619_bg.svg" />
    <img class="pc_agende" src="https://summit-img.geekpark.net/r2020/pc_agende_2.svg" />
    <img
      class="pc_619_title"
      alt="move on"
      src="https://summit-img.geekpark.net/r2020/pc_619_title.svg"
      :style="{transform:`translate3d(${moveOnImgPosition}px,0,0)`}"
    />
    <div class="black_bar" :style="{transform:`translate3d(${moveOnImgPosition}px,0,0)`}" />
    <img class="pc_619_content" src="https://summit-img.geekpark.net/r2020/pc_619_content_3.svg" />
    <div class="guest_wrapper">
      <div class="guest_item_wrapper guest_item_wrapper_top">
        <GuestItem
          v-for="g1_top_item in date19_top "
          :key="g1_top_item.name1"
          :type="g1_top_item.type"
          :title="g1_top_item.title"
          :show_time="g1_top_item.show_time"
          :rightArrow="g1_top_item.rightArrow"
          :slogan="g1_top_item.slogan"
          :avatar1="g1_top_item.avatar1"
          :identity1="g1_top_item.identity1"
          :name1="g1_top_item.name1"
          :id1="g1_top_item.id1"
          :achievement1="g1_top_item.achievement1"
          :sub_achievement1="g1_top_item.sub_achievement1"
          :avatar2="g1_top_item.avatar2"
          :identity2="g1_top_item.identity2"
          :name2="g1_top_item.name2"
          :id2="g1_top_item.id2"
          :achievement2="g1_top_item.achievement2"
          :vSrc="g1_top_item.vSrc"
        />
      </div>
      <div class="guest_item_wrapper">
        <GuestItem
          v-for="g1_bottom_item in date19_bottom"
          :key="g1_bottom_item.name1"
          :type="g1_bottom_item.type"
          :title="g1_bottom_item.title"
          :show_time="g1_bottom_item.show_time"
          :rightArrow="g1_bottom_item.rightArrow"
          :slogan="g1_bottom_item.slogan"
          :avatar1="g1_bottom_item.avatar1"
          :identity1="g1_bottom_item.identity1"
          :name1="g1_bottom_item.name1"
          :id1="g1_bottom_item.id1"
          :achievement1="g1_bottom_item.achievement1"
          :sub_achievement1="g1_bottom_item.sub_achievement1"
          :avatar2="g1_bottom_item.avatar2"
          :identity2="g1_bottom_item.identity2"
          :name2="g1_bottom_item.name2"
          :id2="g1_bottom_item.id2"
          :achievement2="g1_bottom_item.achievement2"
          :vSrc="g1_bottom_item.vSrc"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GuestItem from "./GuestItem.vue";

export default {
  name: "Date_619",
  data() {
    return { moveOnImgPosition: 0, scrollHeight: 0 };
  },
  components: { GuestItem },
  computed: {
    date19_bottom() {
      return this.$store.state.guests.date19_bottom;
    },
    date19_top() {
      return this.$store.state.guests.date19_top;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, false);
  },
  methods: {
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const scrollInstance = scrollHeight - this.scrollHeight;
      this.scrollHeight = scrollHeight;
      const { left, width } = document
        .querySelector(".date_619")
        .getBoundingClientRect();
      if (left <= document.body.offsetWidth && left >= -width) {
        if (
          (scrollInstance > 0 && this.moveOnImgPosition >= -width) ||
          (scrollInstance < 0 && this.moveOnImgPosition <= 0)
        ) {
          this.moveOnImgPosition -= scrollInstance / 16;
        }
      }
      if (this.scrollHeight === 0) {
        this.moveOnImgPosition = 0;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped lang="less">
.date_619 {
  position: relative;
  display: flex;
  align-items: center;
  height: 100vh;
  .pc_619_bg {
    height: 100vh;
    width: auto;
    box-sizing: border-box;
    position: absolute;
    z-index: 1;
  }
  .pc_agende {
    height: 10vh;
    width: auto;
    position: absolute;
    top: 5vh;
    left: 300px;
    z-index: 2;
  }
  .pc_619_title {
    transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
    position: relative;
    height: 53vh;
    width: auto;
    // top: 30vh;
    left: 350px;
    z-index: 2;
  }
  .black_bar {
    transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
    height: calc(2vh + 2px);
    width: 38vh;
    background: #000;
    position: absolute;
    left: 154vh;
    top: 35vh;
    z-index: 3;
  }
  .pc_619_content {
    height: 84vh;
    width: auto;
    position: relative;
    // top: 8vh;
    left: 0;
    z-index: 2;
    padding-left: 300px;
  }
  .guest_wrapper {
    z-index: 2;
    margin-left: 40px;
    .guest_item_wrapper {
      display: flex;
      &.guest_item_wrapper_top {
        margin-bottom: 20px;
      }
    }
  }
}
</style>